import { Component, Input, OnInit } from "@angular/core";
import { MyUtils } from 'src/app/services/my-utils.service';
import { TableFilter, TableFilterOption, TableStructure } from "../../modules/records/models/table-structure";
import { RecordsManager } from "../../modules/records/records-manager";

@Component({
  selector: "app-filter-buttons",
  templateUrl: "./filter-buttons.component.html",
  styleUrls: ["./filter-buttons.component.scss"],
})
export class FilterButtonsComponent<T extends object> implements OnInit {
  buttonSelect = new Map<string, string>();

  @Input() filters: TableStructure<T>["filters"] = [];

  constructor(private recordsManager: RecordsManager<T>, public utils: MyUtils) {}

  ngOnInit(): void {}

  /** Header text shown before a filter's buttons. */
  getFilterLabel(filter: TableFilter): string {
    if (filter.label) {
      return this.utils.traslatei18n(filter.label) + ":";
    }
    return `${this.utils.traslatei18n("Filter By")} ${this.utils.traslatei18n(filter.filterBy)}:`;
  }

  /** i18n key used to render an option's button. */
  optionLabel(option: TableFilterOption): string {
    return typeof option === "string" ? option : option.label;
  }

  /** Value sent to the backend when an option is selected. */
  optionValue(option: TableFilterOption): string {
    return typeof option === "string" ? option : option.value;
  }

  activateButton(filterBy: string, value: string) {
    let current = this.buttonSelect.get(filterBy);
    if (!current || current !== value) {
      this.buttonSelect.set(filterBy, value);
    } else {
      this.buttonSelect.set(filterBy, "");
    }
    this.serverSideFilter();
  }

  serverSideFilter() {
    let o = {};
    this.filters?.forEach((filter) => {
      const selected = this.buttonSelect.get(filter.filterBy) ?? "";
      if (filter.searchColumn) {
        // Emit the SearchColumn/SearchFor pair the endpoint expects.
        Object.assign(o, {
          searchBy: selected ? filter.searchColumn : "",
          searchFor: selected,
        });
      } else {
        Object.assign(o, { [filter.filterBy]: selected !== "All" ? selected : "" });
      }
    });
    this.recordsManager.applyAsyncFilter(o);
  }
}
